import { Injectable } from '@angular/core';

const TENANT_KEY = 'ngidp.auth.tenantId';

/**
 * Persists the active Identity Platform tenant id across reloads.
 *
 * The ID token itself is *not* persisted here — Firebase owns the durable
 * session (IndexedDB) and the token refreshes ~hourly, so caching it would go
 * stale. We only persist the tenant so `Restore Session` can re-apply it on
 * `auth.tenantId` before resolving the current user.
 */
@Injectable({ providedIn: 'root' })
export class TokenStorage {
  getTenantId(): string | null {
    try {
      return localStorage.getItem(TENANT_KEY);
    } catch {
      return null;
    }
  }

  setTenantId(tenantId: string | null): void {
    try {
      if (tenantId) {
        localStorage.setItem(TENANT_KEY, tenantId);
      } else {
        localStorage.removeItem(TENANT_KEY);
      }
    } catch {
      // Storage unavailable (private mode / disabled) — session degrades to
      // in-memory only, which is acceptable.
    }
  }

  clear(): void {
    this.setTenantId(null);
  }
}
